import React from "react";
import StickyTable from "../../../components/common/StickyTable";
import Loader from "../../../components/common/Loader";
import { NoDataFound } from "../../../components/Utils";
import CategoryRow from "./CategoryRow";

const SummaryTable = ({
  categories,
  loading,
  error,
  onRetry,
  expandedCategoryIds,
  onToggleExpand,
  membersCache,
}) => {
  // Grand totals calculation
  const grandTotalMembers = categories.reduce(
    (acc, cur) => acc + (Number(cur.total_members) || 0),
    0
  );
  const grandActiveMembers = categories.reduce(
    (acc, cur) => acc + (Number(cur.active_members) || 0),
    0
  );
  const grandInactiveMembers = categories.reduce(
    (acc, cur) => acc + (Number(cur.inactive_members) || 0),
    0
  );

  return (
    <div className="card icard sticky-table-card">
      <StickyTable refreshDeps={[categories, loading]}>
        <table className="table table-striped itable sticky-action-col">
          <thead>
            <tr>
              <th style={{ width: "80px" }}>Sl. No.</th>
              <th>Category</th>
              <th className="text-end" style={{ width: "140px" }}>
                Total
              </th>
              <th className="text-end" style={{ width: "140px" }}>
                Active
              </th>
              <th className="text-end" style={{ width: "140px" }}>
                Inactive
              </th>
            </tr>
          </thead>
          <tbody className="table-border-bottom-0">
            {loading ? (
              <Loader loading={loading} colspan="5" />
            ) : error ? (
              <tr>
                <td colSpan={5} className="text-center py-4 text-danger">
                  <div>{error}</div>
                  {onRetry && (
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-danger mt-2"
                      onClick={onRetry}
                    >
                      Retry
                    </button>
                  )}
                </td>
              </tr>
            ) : categories.length > 0 ? (
              categories.map((category, index) => {
                const isExpanded = expandedCategoryIds.includes(
                  category.category_id
                );
                const membersData = membersCache[category.category_id];

                return (
                  <CategoryRow
                    key={category.category_id}
                    category={category}
                    index={index}
                    isExpanded={isExpanded}
                    onToggleExpand={onToggleExpand}
                    membersData={membersData}
                  />
                );
              })
            ) : (
              <NoDataFound colspan="5" message="No Data Found" />
            )}
          </tbody>

          {!loading && !error && categories.length > 0 && (
            <tfoot>
              <tr style={{ background: "#f8f9fa", fontWeight: "bold" }}>
                <td colSpan={2}>Grand Total</td>
                <td className="text-end">{grandTotalMembers}</td>
                <td className="text-end text-success">{grandActiveMembers}</td>
                <td className="text-end text-danger">{grandInactiveMembers}</td>
              </tr>
            </tfoot>
          )}
        </table>
      </StickyTable>
    </div>
  );
};

export default SummaryTable;
